var React = require('react');

function OutOfStockIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m10.8 27.3 7.2-7.2 7.2 7.2 2.1-2.1-7.2-7.2 7.2-7.2-2.1-2.1-7.2 7.2-7.2-7.2-2.1 2.1 7.2 7.2-7.2 7.2zm-7.8 8.7c-.8 0-1.5-.3-2.1-.9s-.9-1.3-.9-2.1v-30c0-.8.3-1.5.9-2.1s1.3-.9 2.1-.9h30c.8 0 1.5.3 2.1.9s.9 1.3.9 2.1v30c0 .8-.3 1.5-.9 2.1s-1.3.9-2.1.9zm0-3h30v-30h-30zm.025-30v30z","fill":"#d00000","transform":"translate(0 .8)"}));
}

OutOfStockIcon.defaultProps = {"height":"37","viewBox":"0 0 36 37","width":"36"};

module.exports = OutOfStockIcon;

OutOfStockIcon.default = OutOfStockIcon;
